import Cookies from 'js-cookie';

class IsomorphicCookies {
  constructor(req, res) {
    this.req = req;
    this.res = res;
  }

  get(key) {
    if (this.req) {
      return this.req.cookies[key];
    }
    return Cookies.get(key);
  }

  set(key, val, params) {
    if (this.res) {
      if (params?.expires) {
        const { expires } = params;
        const newExpires = new Date();
        newExpires.setDate(newExpires.getDate() + expires);
        params.expires = newExpires;
      }

      return this.res.cookie(key, val, params);
    }
    return Cookies.set(key, val, params);
  }

  remove(key, params) {
    if (this.res) {
      return this.res.clearCookie(key, params);
    }
    return Cookies.remove(key, params);
  }
}

export default (req = null, res = null) => {
  return new IsomorphicCookies(req, res);
};
